import { styled, keyframes } from '@mui/material/styles';
import { Typography } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

export const OrganizationSettingsRow = styled('div')(({ theme }) => ({
    display: 'flex',
    width: '100%',
    maxWidth: 800,
    marginTop: theme.spacing(4),
    gap: theme.spacing(2),
    [theme.breakpoints.up('sm')]: { gap: theme.spacing(3) },
}));

export const OrganizationNameSection = styled('div')({ flex: 1, minWidth: 0 });

export const LogoSection = styled('div')(({ theme }) => ({
    flex: 1,
    minWidth: 0,
    paddingLeft: theme.spacing(2),
    borderLeft: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.up('sm')]: { paddingLeft: theme.spacing(3) },
}));

export const LogoTitle = styled(Typography)(({ theme }) => ({ marginBottom: theme.spacing(1) }));

export const LogoControls = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    '& .MuiButton-root.Mui-focusVisible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 2,
    },
}));

export const LogoPreview = styled('div')({
    width: 100,
    height: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const LogoImage = styled('img')({ width: '100%', height: '100%', objectFit: 'contain' });
export const EmptyLogoIcon = styled(ImageOutlinedIcon)({ fontSize: 40 });

const spin = keyframes`from { transform: rotate(0deg); } to { transform: rotate(360deg); }`;

export const LogoSpinner = styled('span')({
    display: 'inline-block',
    boxSizing: 'border-box',
    width: 16,
    height: 16,
    border: '2px solid currentColor',
    borderRightColor: 'transparent',
    borderRadius: '50%',
    animation: `${spin} 0.8s linear infinite`,
    '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
});

export const LogoPreviewSpinner = styled(LogoSpinner)(({ theme }) => ({
    width: 32,
    height: 32,
    color: theme.palette.primary.main,
}));
